// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__RdkBN","amount":"Amount_amount__2T-0L","tip":"Amount_tip__1zvY1","tipHeader":"Amount_tipHeader__Dvs8U","tipsWrap":"Amount_tipsWrap__35PdN"};